'use strict';

import Vue from 'vue';
import axios from 'axios';

let config = {
    baseURL: process.env.VUE_APP_LOCATION
};

const _axios = axios.create(config);

_axios.interceptors.request.use(function (config) {
    const Store = window.localStorage.getItem('Store');
    // Do something before request is sent
    // console.log('personal token is wrong if is shop owner')
    config.headers = {...config.headers,
        Authorization: 'Basic ' + window.localStorage.getItem('tokenCPH')
    };
    /*if (Store) {
        config.headers.Store = Store;
    }*/
    return config;
}, function (error) {
    // Do something with request error
    return Promise.reject(error);
});

// Add a response interceptor
_axios.interceptors.response.use(
    function (response) {
    // Do something with response data
        return response;
    },
    function (error) {
    // Do something with response error
        return Promise.reject(error);
    }
);

Plugin.install = function (Vue, options) {
    Vue.axios = _axios;
    window.axios = _axios;
    Object.defineProperties(Vue.prototype, {
        axios: {
            get () {
                return _axios;
            }
        },
        $axios: {
            get () {
                return _axios;
            }
        }
    });
};


Vue.use(Plugin);

export default Plugin;
